<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("Import.import", [objName]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-left my-2">
              {{ $t("StockTakeOrders.downloadFieldTemplate", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-row>
                <v-col cols="12" sm="8" md="8">
                  <v-autocomplete
                    v-model="categorySelected"
                    :items="items"
                    item-text="category_name"
                    item-value="category_code"
                    label="商品分类"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4" align-self="center">
                  <v-btn color="primary" dark class="ms-1" @click="download()">
                    {{ $t("Import.downloadFieldTemplateBtn") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-subtitle>
            <v-list-item-title class="text-left my-2">
              {{ $t("StockTakeOrders.uploadField", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-file-input
                v-model="excelFile"
                show-size
                :label="$t('Import.fileInputLabel')"
                accept=".xls,.xlsx"
              ></v-file-input>
            </v-list-item-subtitle>
            <span v-if="isTips">
              <v-list-item-title class="text-left my-2">
                {{ $t("$vuetify.alert") }}
              </v-list-item-title>
              <v-list-item-subtitle
                class="text-left my-1"
                v-for="detail in tipDetails"
                :key="detail"
              >
                {{ detail }}
              </v-list-item-subtitle>
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed @click="$emit('import', excelFile)">
          {{ $t("Import.confirmImport") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import StockTakeOrders from "@/api/stock_take_orders";
import MaterialCategories from "@/api/stock_materials";
export default {
  name: "ImportExcelDialog",

  props: {
    value: Boolean,
    title: String,
    objName: String,
    isTips: Boolean,
    tipDetails: Array,
    downloadFromAPI: Boolean,
    downloadTemplateUrl: String,
    stock_id: Number,
    mode: String,
    type: Number,
  },

  data: () => ({
    dialog: false,
    excelFile: null,
    categorySelected: null,
    category_code: null,
    items: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        this.getMaterialCategoriesFromAPI();
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.excelFile = null;
        }
        this.$emit("input", this.dialog);
      },
    },

    stock_id: {
      handler() {
        this.getMaterialCategoriesFromAPI();
      },
    },
  },
  methods: {
    download() {
      if (!this.categorySelected) {
        this.categorySelected = "";
      }
      if (this.mode == "regularNew") {
        var data = {
          stock_id: this.stock_id,
          category_code: this.categorySelected,
        };
        if (this.type == 2) {
          data = Object.assign({}, data, {
            delete_stock_count: 1,
          });
        }
        StockTakeOrders.commonTemplatexport(data);
      } else if (this.mode == "batchNew") {
        StockTakeOrders.batchTemplateExport(
          this.stock_id,
          this.categorySelected
        );
      } else if (this.mode == "new") {
        StockTakeOrders.positionTemplateExport(
          this.stock_id,
          this.categorySelected
        );
      }
    },

    getMaterialCategoriesFromAPI() {
      this.materialCategoriesLoading = true;
      if (this.stock_id) {
        MaterialCategories.getCategories({ stock_id: this.stock_id })
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.items = response.data.categories;
              }
              this.materialCategoriesLoading = false;
            }.bind(this)
          )
          .catch(
            function () {
              this.materialCategoriesLoading = false;
            }.bind(this)
          );
      }
    },
  },
};
</script>